import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f263176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Video" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_UploadComp = _resolveComponent("UploadComp")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules,
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "视频类别",
          prop: "videoTypeId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              ref: el=>_ctx.refMap.set('videoTypeId',el),
              modelValue: _ctx.form.videoTypeId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.videoTypeId) = $event)),
              clearable: "",
              placeholder: "请选择视频类别",
              style: {"width":"100%"},
              disabled: _ctx.disabled,
              onChange: _cache[1] || (_cache[1] = (val)=>{_ctx.selectOnChange(val,'videoTypeId')})
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboSelect({comboId:'videoTypeId'}), (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value,
                    disabled: item.disabled
                  }, null, 8, ["label", "value", "disabled"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              onInput: _cache[2] || (_cache[2] = e => _ctx.form.name = _ctx.valid(e)),
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
              placeholder: "请输入视频名称",
              maxlength: "100",
              disabled: _ctx.disabled,
              clearable: ""
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "desc"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              onInput: _cache[4] || (_cache[4] = e => _ctx.form.desc = _ctx.valid(e)),
              modelValue: _ctx.form.desc,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.desc) = $event)),
              type: "textarea",
              placeholder: "请输入描述",
              maxlength: "250",
              disabled: _ctx.disabled,
              clearable: ""
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    (_ctx.form.id)
      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_UploadComp, _mergeProps(_ctx.buildUploadInitParams({uploadType:'video',type:5,title:'视频'}), {
                  ref: el=>_ctx.refMap.set('video',el)
                }), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}